import { render } from "./WebsitePalette.vue?vue&type=template&id=222cef64&scoped=true"
import script from "./WebsitePalette.vue?vue&type=script&lang=js"
export * from "./WebsitePalette.vue?vue&type=script&lang=js"

import "./WebsitePalette.vue?vue&type=style&index=0&id=222cef64&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222cef64"]])

export default __exports__